    <p-table
      [value]="history"
      [loading]="isLoading"
      [paginator]="true"
      [alwaysShowPaginator]="false"
      [rows]="10"
      [sortOrder]="-1"
      sortField="etlChangeInsertDate"
      [showCurrentPageReport]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Date</th>
          <th>Network</th>
          <th>Participation Status</th>
          <th>Effective Start Date</th>
          <th>Effective End Date</th>
          <th>Reimbursement Type </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.etlChangeInsertDate | utcToLocal: 'MM/dd/yyyy' }}</td>
          <td>{{ item.participatingNetworks }}</td>
          <td>
            <div class="p-field-checkbox-container checkbox-align">
              <p-checkbox
                binary="true"
                [disabled]="true"
                [ngModel]="item?.participationStatus"
              ></p-checkbox>
            </div>
          </td>
          <td>{{ item.effectiveStartDate | utcToLocal: 'MM/dd/yyyy' }}</td>
          <td>{{ item.effectiveEndDate | utcToLocal: 'MM/dd/yyyy' }}</td>
          <td>{{ item.reimbursementType }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6">
            No history records found
          </td>
        </tr>
      </ng-template>
    </p-table>
